import { render, staticRenderFns } from "./UserMessages.vue?vue&type=template&id=0b0b0721&scoped=true&"
import script from "./UserMessages.vue?vue&type=script&lang=ts&"
export * from "./UserMessages.vue?vue&type=script&lang=ts&"
import style0 from "./UserMessages.vue?vue&type=style&index=0&id=0b0b0721&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b0721",
  null
  
)

export default component.exports